<template>
  <el-form
    ref="phoneForgotForm"
    :model="form.field"
    status-icon
    :validate-on-rule-change="false"
    label-width="130px"
    :show-message="false"
  >
    <el-form-item required prop="captcha" :label="$t('cmsg.captcha')" :error="form.errors.Captcha">
      <el-input v-model="form.field.captcha" @keyup.enter.native="onSubmit">
        <el-button slot="prepend" class="captcha_img" @click="new_captcha">
          <img :src="form.captcha_img" v-if="form.captcha_img">
        </el-button>
      </el-input>
    </el-form-item>
    <el-row>
      <el-col :span="12">
        <el-form-item
          required
          prop="phoneArea"
          :label="$t('cmsg.mobile')"
          :error="form.errors.PhoneArea"
          :rules="[
        {required: true,message:$t('cmsg.required')},
        {type: 'number',message:$t('cmsg.integerRequired')}
        ]"
        >
          <el-select
            v-model="form.field.phoneArea"
            v-model.number="form.field.phoneArea"
            filterable
            :placeholder="$t('cmsg.countryCode')"
          >
            <el-option v-for="i in $countryCodes" :label="i.label" :value="i.value" :key="i.label"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          required
          prop="username"
          label-width="0px"
          :error="form.errors.Username"
          :rules="[
        {required: true,message:$t('cmsg.required')},
        {type: 'number',message:$t('cmsg.integerRequired')}
        ]"
        >
          <el-input
            v-model="form.field.username"
            v-model.number="form.field.username"
            :placeholder="$t('cmsg.mobile')"
            @keyup.enter.native="onSubmit"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item required prop="smsCode" :label="$t('cmsg.smsCode')" :error="form.errors.SmsCode">
      <el-input
        v-model="form.field.smsCode"
        :placeholder="$t('cmsg.smsCode')"
        @keyup.enter.native="onSubmit"
      >
        <el-button
          type="info"
          @click="smsSubmit"
          slot="append"
          :disabled="form.smsLoading"
        >{{smsBtn}}</el-button>
      </el-input>
    </el-form-item>
    <el-form-item required prop="password" :label="$t('cmsg.newPwd')" :error="form.errors.Password">
      <el-input
        v-model="form.field.password"
        type="password"
        :placeholder="$t('cmsg.newPwd')"
        @keyup.enter.native="onSubmit"
      ></el-input>
    </el-form-item>
    <el-form-item required prop="npassword" :label="$t('cmsg.newPwdAgain')">
      <el-input
        v-model="form.field.npassword"
        type="password"
        :placeholder="$t('cmsg.newPwdAgain')"
        @keyup.enter.native="onSubmit"
      ></el-input>
    </el-form-item>
    <br>
    <!-- <p class="bg-danger" v-if="form.err">{{form.err}}</p> -->
    <el-form-item>
      <el-button
        type="primary"
        @click="onSubmit"
        class="submit_btn"
        :loading="form.loading"
      >{{$t('cmsg.submit')}}</el-button>
    </el-form-item>
    <p style="text-align: left;">
      {{$t('cmsg.orBackTo')}}
      <router-link :to="{name:'login'}">
        <el-button type="text">{{$t('cmsg.loginBtn')}}</el-button>
      </router-link>
    </p>
  </el-form>
</template>

<script>
import Cookies from "js-cookie";
export default {
  name: "phone-forgot",
  data() {
    return {
      smsBtn: this.$t("cmsg.sendSMS"),
      smsTime: 300,
      form: {
        captcha_img: "",
        field: {
          uuid: "",
          uuidSms: "",
          lang: Cookies.get("lang") || "cn",
          captcha: "",
          loginType: "",
          username: null,
          password: "",
          npassword: "",
          phoneArea: null
        },
        errors: {
          SmsCode: null,
          Captcha: null,
          Username: null,
          Password: null,
          PhoneArea: null
        },
        smsLoading: false,
        loading: false,
        err: ""
      }
    };
  },
  methods: {
    smsSubmit() {
      console.log(this.form.field);
      // this.form.loading = true;
      this.form.err = "";
      this.form.field.username = parseInt(this.form.field.username);
      this.form.field.phoneArea = parseInt(this.form.field.phoneArea);
      var smsField = this.form.field;

      smsField.username = smsField.username.toString();
      smsField.phoneArea = smsField.phoneArea.toString();
      if (
        smsField.captcha === "" ||
        smsField.phoneArea === "" ||
        smsField.username === ""
      ) {
        this.form.err = this.$t("cmsg.smsCaptcha");
        return false;
      }
      this.form.smsLoading = true;
      //   console.log(this.form.field);
      this.smsTimer();
      this.$axios
        .post(`/api/sms/bpcode`, smsField, {
          json: true,
          validateStatus: function(status) {
            return status >= 200 && status < 404; // default
          }
        })
        .then(res => {
          // console.log("res: ", res.data.result.perms);
          if (res.data && res.data.status !== "success") {
            console.log(res.data.result);
                var ermsg = {};
                var fs = [];
                try {
                  ermsg = JSON.parse(res.data.result);
                } catch (e) {
                  console.log(e);
                }
                Object.keys(ermsg).map((erk, i) => {
                  this.form.errors[erk] = this.$t("cmsg.errField");
                  fs.push(erk);
                });
                this.form.err = res.data.result;
                this.$message({
                  type: "error",
                  duration:0,
                  showClose:true,
                  message: fs.join(",")+this.$t("cmsg.errField")
                });
            this.form.smsLoading = false;
          } else {
            setTimeout(function() {
              this.form.smsLoading = false;
            }, 300000);
          }
        })
        .catch(err => {
          console.log("err: ", err);
          this.form.err = this.$t("cmsg.mting");
          this.form.smsLoading = false;
        });
    },
    smsTimer() {
      if (this.smsTime > 0) {
        this.smsTime--;
        this.smsBtn = this.$t("cmsg.sendingSMS", { time: this.smsTime });
        setTimeout(this.smsTimer, 1000);
      } else {
        this.smsTime = 300;
        this.smsBtn = this.$t("cmsg.sendSMS");
        this.form.smsLoading = false;
      }
    },
    onSubmit() {
      this.form.err = "";
      // var vueObj = this;
      if (this.form.field.password !== this.form.field.npassword) {
        this.form.err = this.$t("cmsg.twoPwdMatch");
        this.form.errors["Password"] = this.$t("cmsg.twoPwdMatch");
        return false;
      }
      this.form.field.username = parseInt(this.form.field.username);
      this.form.field.phoneArea = parseInt(this.form.field.phoneArea);
      this.$refs["phoneForgotForm"].validate(valid => {
        if (valid) {
          this.form.loading = true;
          //   console.log(this.form.field);
          this.form.field.username = this.form.field.username.toString();
          this.form.field.phoneArea = this.form.field.phoneArea.toString();
          this.$axios
            .post(`/api/sms/user`, this.form.field, {
              json: true,
              validateStatus: function(status) {
                return status >= 200 && status < 404; // default
              }
            })
            .then(res => {
              // console.log("res: ", res.data.result.perms);
              if (res.data && res.data.status === "success") {
                this.$message({
                  type: "success",
                  message: this.$t("cmsg.successAction")
                });
                var t = this;
                setTimeout(function() {
                  // window.location = t.$router.resolve({
                  //   name: "enLogin"
                  // }).href;
                  t.$redirect({ name: "login" });
                }, 3000);
                // this.$router.push({name:"cases"});
              } else {
                this.form.field.username = parseInt(this.form.field.username);
                this.form.field.phoneArea = parseInt(this.form.field.phoneArea);
                console.log(res.data.result);
                var ermsg = {};
                var fs = [];
                try {
                  ermsg = JSON.parse(res.data.result);
                } catch (e) {
                  console.log(e);
                }
                Object.keys(ermsg).map((erk, i) => {
                  this.form.errors[erk] = this.$t("cmsg.errField");
                  fs.push(erk);
                });
                this.form.err = res.data.result;
                this.$message({
                  type: "error",
                  duration:0,
                  showClose:true,
                  message: fs.join(",")+this.$t("cmsg.errField")
                });
                console.log(this.form.errors);
                // this.form.err = res.data.result;
                this.form.loading = false;
              }
            })
            .catch(err => {
              console.log("err: ", err);
              this.form.err = this.$t("cmsg.mting");
              this.form.loading = false;
            });
        } else {
          this.form.loading = false;
          return false;
        }
      });
    },
    new_captcha() {
      this.$axios
        .get(
          `/api/captcha/${this.$gf.uuid()}?w=180&h=31&p=pf-${
            pub.loginSdk
          }&e=86400`,
          {
            validateStatus: function(status) {
              return status >= 200 && status < 404; // default
            }
          }
        )
        .then(res => {
          if (
            res &&
            res.data &&
            res.data.result &&
            res.data.status === "success"
          ) {
            this.form.captcha_img = res.data.result;
          } else {
            this.form.captcha_img = "";
          }
        });
    }
  },
  mounted() {
    var tLang = Cookies.get("lang");
    if (tLang === "cn" || !tLang) {
      this.form.field.phoneArea = 86;
    }
    this.form.field.loginType = pub.loginSdk;
    this.form.field.uuid = "pf-" + pub.loginSdk + "-" + this.$gf.uuid();
    this.form.field.uuidSms =
      "pf-" + pub.loginSdk + "-smscode-" + this.$gf.uuid();
    this.new_captcha();
  }
};
</script>
<style>
.el-col {
  text-align: left;
}
.el-col .el-form-item {
  width: 100%;
}
.el-col .el-form-item .el-select {
  width: 100%;
}
.el-form-item:not(:nth-last-of-type(1)) {
  margin-bottom: 15px;
}
.el-form-item:first-of-type {
  margin-bottom: 20px;
}
.submit_btn {
  width: 100%;
}
</style>
